import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, secondaryColor, styleColors} from "src/main.style";

export const EcoFloatingButtonStyle = (theme: Theme) =>
  createStyles({
    container : {
      position: "absolute",
      bottom: 100,
      right: 20,
      zIndex: 1200,
    },
    fab: {
      borderRadius: "50%",
      boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
      backgroundColor: primaryColor,
      /* FAB background is a fixed brand color in both themes — icon must
         always be actual white, not styleColors.white (which flips to
         the card surface in dark mode). */
      color: '#FFFFFF',
      maxWidth: "62px",
      maxHeight: "62px",
      minWidth: "62px",
      minHeight: "62px",
      cursor: "pointer",
      userSelect: "none",
      WebkitUserSelect: 'none',
      transition: "all 0.2s",
      overflow: "hidden",
      boxSizing: "border-box",
      fontSize: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    purple : {
      boxShadow: '0px 3px 30px '+secondaryColor+'47',
      backgroundColor: secondaryColor,
      fontSize: '16px',
      fontWeight: 500,
    },
    grey :  {
      backgroundColor: styleColors.greyDark1,
    },
    expanded : {
      maxWidth: "300px",
      maxHeight: "150px",
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '12px',
      padding: '12px',
      gap: '12px',
      alignItems: 'flex-end',
    },
    FABlabel : {
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px',
      fontSize: '16px',
      fontWeight: 500,
      width: '100%',
      boxSizing: 'border-box',
      justifyContent: 'space-between',
    },
    aiFailedBackground : {
      backgroundColor: primaryColor,
      width: '62px',
      height: '62px',
      borderRadius: '99px',
    },
    aiReadyBackground : {
      background: `linear-gradient(60deg,${styleColors.rainbowBlue},${styleColors.rainbowViolet},${styleColors.rainbowMagenta},${styleColors.coralRed},${styleColors.rainbowOrange},${styleColors.rainbowLime},${styleColors.rainbowGreen},${styleColors.rainbowCyan})`,
      backgroundSize: '186px 186px',
      animation: `$moveGradient 4s alternate infinite`,
      boxShadow: '0px 3px 30px '+secondaryColor+'ad',
      width: '62px',
      height: '62px',
      borderRadius: '99px',
    },
    '@keyframes moveGradient' : {
      '50%':{
        backgroundPosition: '-124px -124px',
      }
    },
    aiAnalyzingBackground : {
      background: `conic-gradient(from 90deg at 50% 50%, ${styleColors.greyDark1}, ${styleColors.white}, ${styleColors.greyDark1}, ${styleColors.white}, ${styleColors.greyDark1})`,
      animation: `$rotateGradient 2s infinite linear`,
      boxShadow: '0px 3px 30px '+secondaryColor+'ad',
      backgroundSize: '124px 124px',
      width: '62px',
      height: '62px',
      borderRadius: '99px',
    },
    '@keyframes rotateGradient' : {
      '0%' :{
        backgroundPosition: '0px 0px',
      },
     '50%': {
        backgroundPosition: '62px 62px',
      },
      '100%' : {
        backgroundPosition: '0px 0px',
      }
    },
  });



// WEBPACK FOOTER //
// ./src/components/economy/EcoFloatingButton.style.ts